import { AlertIcon } from "@/assets/svgs";
import { Button } from "@/components/ui/button";

const ErrorPage: React.FC = () => (
  <div className="flex min-h-dvh flex-col items-center justify-center p-4">
    <AlertIcon className="mb-10" />

    <h2 className="text-4xl font-bold mb-4">Something went wrong!</h2>
    <p className="text-black mb-10">Please try again.</p>

    <Button variant="default" onClick={() => window.location.reload()}>
      <span>Try again</span>
    </Button>
  </div>
);

export default ErrorPage;
